import {React, useState} from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'

function ColorPickerf(props){

  const [displayColorPicker, setDisplayColorPicker]  =     useState(false);
  const [color, setColor]  =     useState(props.color || {r: 255, g: 255, b: 255, a: 1});

 const handleClick = () => {
    if(props.isDisabled){
      setDisplayColorPicker(false)
    }
    else{
      setDisplayColorPicker(!displayColorPicker);
    }
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  }

  const handleChange = (color) => {
    setColor(color.rgb);
    props.handleChange(color);
  }

  function rgbaToHex(rgba) {
    try{
      let str = "#"
      str = str + rgba.r.toString(16).padStart(2, '0');
      str = str + rgba.g.toString(16).padStart(2, '0');
      str = str + rgba.b.toString(16).padStart(2, '0');
      return str.toUpperCase() + ' | ' + parseInt(rgba.a * 100) + '%'
    }
    catch(error) {
      console.log(rgba)
      return ""
    }
  }


  const styles = reactCSS({
    'default': {
        color: {
          width: '21px',
          height: '21px',
          border: `1px solid rgba(${ color.r }, ${ color.g }, ${ color.b }, ${ color.a })`,
          borderRadius: '3px',
          background: `rgba(${ color.r }, ${ color.g }, ${ color.b }, ${ color.a })`,
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
          top: 'auto',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
    },
  });


   return (
     <>
   <div style={ styles.swatch } onClick={handleClick } className={`Dpflex colorpickerpostion`}>
      <div style={ styles.color } />
      <div className={`ml15`}>{rgbaToHex(color)}</div>
    </div>
{ displayColorPicker ? <div style={ styles.popover }>
      <div style={ styles.cover } onClick={handleClose }/>
      <SketchPicker color={color}
        onChange={handleChange }
      />
    </div> : null
  }
  </>
   );
}
export default ColorPickerf;